<template>
    <v-layout row wrap v-if="messageList">
      <div v-if="getShowModalMessageResult">{{processModalResult()}}</div>
      <v-flex xs12 v-for="(message, index) in messageList" :key="index">
       
        <div :class="['message-list__item--'+message.message_type, 'message-list__item']" @click="showMessage(index)">
            <strong v-if="message.passed == 0">{{message.title}}</strong>
            <span v-if="message.passed != 0"><b>{{message.title}}</b> - <span>{{getMessageDescriptionExcerpt(message.description)}}</span></span>
            <span class="message-list-item__date">{{getNicerDateFormat(message.date)}}</span>


            <div class="message-list-item__action-panel">
                <v-icon class="margin-left-auto">more_vert</v-icon>                        
                <v-icon @click="tryDeleteMessage(index)">delete</v-icon>                        
            </div>
        </div>
          
        <div class="message-list-item__description" v-if="showIndex == index">
            <v-icon class="btn-close" @click="showIndex = -1">close</v-icon>  
        
            <div v-if="messageList">
                <div v-html="message.description"></div>
            </div>
        </div>            
      </v-flex>  
  </v-layout>
</template>

<script>

import {mapGetters} from 'vuex'
import axios from '../../axios-auth'

export default {
    data() {
      return {
          showIndex: -1,
          deleteIndex: -1
      }
    },
    computed: 
        mapGetters([
            'getShowModalMessageResult'                    
        ]),
   props : ['messageList'],
   methods: {
    showMessage(index) {
        this.showIndex = index
        const data = {
          message_id: this.messageList[index].message_id
      }
      axios.post('/pass-message', data, this.$store.getters.getAxiosConfig)
        .then(res => {
            // set data to store
            if (res.data.message == 'OK') {
                this.messageList[index].passed = 1
            }
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
    tryDeleteMessage(index) {
        this.deleteIndex = index
        this.$store.commit('setShowModalMessage',
                    {content: 'Are you sure?<br/>You want to delete message "' + this.messageList[index].title + '"', type: 'warning', 
                    buttons:[], icons:[{text:'close', color:'red', value: 1},{text:'done', color:'green', value: 2} ]})
    },
    deleteMessage(){
      this.feedback = null
      const data = {
          message_id: this.messageList[this.deleteIndex].message_id
      }
      axios.post('/delete-message', data, this.$store.getters.getAxiosConfig)
        .then(res => {
            // set data to store
            if (res.data.message == 'OK') {
                this.messageList.splice(this.deleteIndex,1)
            }
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
    processModalResult() {
        const res = this.getShowModalMessageResult
        this.$store.commit('setShowModalMessageResult',null)
        if (res == 2) {
            this.deleteMessage()
        }
    },
    getNicerDateFormat(date) {
            if (date == '') return "N/A"
            const dateVar = new Date(date.replace(/\s/, 'T'));
            return (dateVar.getDate()+". "+("0"+(dateVar.getMonth()+1)).slice(-2)+"., "+dateVar.getHours()+":"+("0"+(dateVar.getMinutes())).slice(-2)); // getMonth()+1 - (January gives 0)
    },
    getMessageDescriptionExcerpt(description) {
        var excerpt = description;
        return excerpt.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ').substring(0, 30) + "...";
    }
   }
  }
</script>

<style>
</style>